export default __webpack_public_path__ + "static/media/ContentCopy.2f646a83.svg";